import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { tagParser, linkParser, isTouchDevice } from '../../../js/modules/utilities.js'
import { updateCookieCampaign } from '../utils'

import imgScotchDouble from './assets/bandeau-scotch-double.png'

export const BlackFriday1 = ({ videoURL, videoPosterURL, title, label, URL, analytics, DAS, legalNotice }) => {
   const videoRef = useRef(null)

   useEffect(() => {
      updateCookieCampaign('apbf', new Date('2024-12-05'))
   }, [])

   return (
      <div class="campagneBlackFriday1">
         <a
            href={URL}
            data-pdb-zid={analytics.pdbZid}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="content">
               <div class="inner-content">
                  <h2 class="h1 mb-1 mb-md-2 title" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
                  <span class="btn btn-primary">{label}</span>
               </div>
               {(legalNotice.content || legalNotice.title) && <LegalNotice {...legalNotice} />}
            </div>
            <video
               ref={videoRef}
               class="video"
               playsinline // mobile: evite le fullscreen
               autoplay
               preload="auto"
               muted
               poster={videoPosterURL}
               tabIndex="-1"
            >
               <source src={videoURL} type="video/mp4" />
            </video>

            <VideoControls videoRef={videoRef} />
            {DAS && <Das DAS={DAS} />}
         </a>
      </div>
   )
}

export const BlackFriday2 = ({ videoURL, videoPosterURL, title, label, URL, analytics, DAS, legalNotice }) => {
   const videoRef = useRef(null)

   useEffect(() => {
      updateCookieCampaign('bf', new Date('2024-12-05'))
   }, [])

   // image scotch double
   document.documentElement.style.setProperty('--img-scotch-double', `url(${imgScotchDouble})`)

   return (
      <div class="campagneBlackFriday2">
         <a
            href={URL}
            data-pdb-zid={analytics.pdbZid}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="content">
               <div class="inner-content">
                  <h2 class="h1 mb-1 mb-lg-2 title" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
                  <span class="btn btn-primary btn-inverse">{label}</span>
               </div>
               {(legalNotice.content || legalNotice.title) && <LegalNotice title={legalNotice.title} content={legalNotice.content} background="black" />}
            </div>
            <video
               ref={videoRef}
               class="video"
               playsinline // mobile: evite le fullscreen
               autoplay
               preload="auto"
               muted
               loop
               poster={videoPosterURL}
               tabIndex="-1"
            >
               <source src={videoURL} type="video/mp4" />
            </video>

            <VideoControls videoRef={videoRef} />
            {DAS && <Das DAS={DAS} />}
         </a>
      </div>
   )
}

// VIDEO CONTROLS =============================================
const VideoControls = ({ videoRef }) => {
   const iconPlay = (
      <svg width="18" height="20" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg">
         <path fill="#ffffff" d="M8.94821 14.7252L0 19.4253V0.625L8.94821 5.32507L17.6253 10.0251L8.94821 14.7252Z" />
      </svg>
   )
   const iconPause = (
      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
         <path fill="#ffffff" d="M7.27511 17.6253H0.375V0.375H7.27511V17.6253ZM17.6253 17.6253H10.7252V0.375H17.6253V17.6253Z" />
      </svg>
   )
   const iconReplay = (
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
         <path
            fill="#ffffff"
            d="M13.5 2c-5.621 0-10.211 4.443-10.475 10h-3.025l5 6.625 5-6.625h-2.975c.257-3.351 3.06-6 6.475-6 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-1.863 0-3.542-.793-4.728-2.053l-2.427 3.216c1.877 1.754 4.389 2.837 7.155 2.837 5.79 0 10.5-4.71 10.5-10.5s-4.71-10.5-10.5-10.5z"
         />
      </svg>
   )
   const [isPlaying, setIsPlaying] = useState(true)
   const [hasEnded, setHasEnded] = useState(false)

   const handlePlayPause = (e) => {
      e.preventDefault() // evite le clic sur le lien
      e.stopPropagation() // evite l'envoi du taggage
      if (isPlaying) {
         videoRef.current.pause()
      } else {
         videoRef.current.play()
      }
      setHasEnded(false)
      setIsPlaying(!isPlaying)
   }

   // video ended
   const handleVideoEnded = () => {
      setIsPlaying(false)
      setHasEnded(true)
   }
   useEffect(() => {
      videoRef.current.addEventListener('ended', handleVideoEnded)
   }, [])

   return (
      <button class="play-pause-btn btn" onClick={handlePlayPause}>
         {isPlaying ? iconPause : hasEnded ? iconReplay : iconPlay}
      </button>
   )
}

// DAS ========================================================
const Das = ({ DAS, color = 'white' }) => {
   const [tooltip, setTooltip] = useState(false)
   const toggleTooltip = (e) => {
      e.preventDefault() // evite le clic sur le lien
      e.stopPropagation() // evite l'envoi du taggage
      setTooltip((prevTooltip) => !prevTooltip)
   }
   return (
      <div class="das">
         <div class={`text-dark ob1-tooltip ${tooltip && 'active'}`}>
            <button class="ob1-tooltip-trigger picto-das btn" onClick={toggleTooltip}>
               <span class={`icon icon-info text-${color}`} aria-hidden="true"></span>
               <strong class={`text-${color}`}>DAS</strong>
            </button>

            <div class="ob1-tooltip-content ob1-tooltip-top ob1-tooltip-top-left" id="tooltip-content-top">
               <span dangerouslySetInnerHTML={{ __html: tagParser(DAS) }}></span>
            </div>
            <div class="ob1-tooltip-shadow"></div>
         </div>
      </div>
   )
}

// MENTIONS LEGALES ===========================================
const LegalNotice = ({ showButtonLabel = 'Voir conditions', title, content, background = 'white', index = 0 }) => {
   const [legalState, setLegalState] = useState(false)
   const [legalHoverState, setLegalHoverState] = useState(false)

   const toggleLegals = (e) => {
      e.preventDefault() // evite le clic sur le lien
      e.stopPropagation() // evite l'envoi du taggage
      setLegalState(!legalState)
   }

   const showLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(true)
   }

   const hideLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(false)
   }

   return (
      <div
         class={`legalNoticeWrapper ${legalState ? 'openContent' : ''} ${legalHoverState ? 'isHover' : ''} ${background === 'white' ? 'grey-bg' : 'black-bg'}`}
         onMouseLeave={hideLegals}
      >
         <div id={`legalNoticePanel${index}`} class="contentLegalNotice" aria-hidden={!legalState}>
            <span class="closeLegal" onClick={toggleLegals}>
               &times;
            </span>
            <div class="contentText">
               {title && <div class="legalNoticeTitle" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></div>}
               {content && <div dangerouslySetInnerHTML={{ __html: tagParser(linkParser(content)) }}></div>}
            </div>
         </div>
         <button
            class="showButton btn"
            onClick={toggleLegals}
            onMouseEnter={showLegals}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls={`legalNoticePanel${index}`}
         >
            <span class="icon icon-info"></span>&nbsp;<span class="showButton-label">{showButtonLabel}</span>
         </button>
      </div>
   )
}
